import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getOtherTasks } from './selectors';
import {
  displayStepForm,
  setOpenStepFormTabEntityDisplay,
} from '../../actions/EntityDisplayActions';
import { useFormSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { useWindowDimensions } from '../../custom-hooks/useWindowDimensions';
import { getNetworkStatus } from '../../form-designer/selectors/common.selectors';
import { decodeString } from '../../utils/commonUtils';
import MenuButton from '../MenuButton';

const OtherTasks = () => {
  const dispatch = useDispatch();
  const otherTasks = useFormSelector(getOtherTasks);
  const translateString = useTranslation();
  const { isMobileDevice } = useWindowDimensions();
  const isOnline = useSelector(getNetworkStatus);

  const otherTasksOptions = otherTasks.map((task) => {
    const taskName = task.translatedText ?? '---';
    const tooltip = decodeString(task.toolTip.replace(/\r/g, '\n'));

    return {
      id: `${taskName}-${tooltip}`,
      text: taskName,
      isGroupHeader: task.isGroupHeader,
      isGroupEmpty: task.isGroupEmpty,
      tooltip,
      onClick: () => {
        const actionData = task.referencedActionData ?? {};
        isMobileDevice && dispatch(setOpenStepFormTabEntityDisplay(true));
        dispatch(
          displayStepForm({
            containerWorkflowKey: actionData.ContainerWorkflowKey,
            workflowKey: actionData.WorkflowKey,
            stepId: actionData.StepID,
            itmId: actionData.ItmID,
            workflowId: actionData.WorkflowID,
            parentWorkflowId: actionData.ParentWorkflowId,
            actionName: actionData.ActionName,
          })
        );
      },
    };
  });

  return (
    <MenuButton
      buttonText={translateString('Task')}
      menuItems={otherTasksOptions}
      disabled={otherTasksOptions.length === 0 || !isOnline}
    />
  );
};

export default OtherTasks;
